import { observer } from "mobx-react-lite";
import * as React from "react";
import { useStore } from "../../root-store-context";
import { useEffect } from "react";
import { Col, Pagination, Row, Tag, message, Select } from "antd";
import utilsFunc from '../../utils/utilsFunc'
import { RenderAddressAndPropertyColumns } from "./microComponents/RenderAddressAndPropertyColumns"
import { RenderModalWindowReassignEmail } from "./microComponents/RenderModalWindowReassignEmail";
import { RenderModalResetPassword } from "./microComponents/RenderModalResetPassword";
import { RenderModalResetPasswordMessage } from "./microComponents/RenderModalResetPasswordMessage";
import { getUserResetPasswordWeb } from "../../api/getUserResetPasswordWeb";
import DynamicTable from "../../../../../../../Components/Table/Table";
import Spinner from "../../../../../../../Components/Spinner/Spiner";

export const TableUserListToManage = observer(()=> {

    const [messageApi ,contextHolder] = message.useMessage();
    const {userListToManageStore: 
        {
            data,isLoading,isOpenModalReassignEmail,isOpenModalResetPassword,reassignEmail,fullNameResetPassword,accountIdResetPassword,isOpenModalResetPasswordInfo,newTimePassword,newReassignEmails,selectedNewResidentKey,selectedNewContactKey,isReassignEmailError,
            getUserListToManageAction,openModalReassignEmail,closeModalReassignEmail,openModalResetPassword,closeModalResetPassword,openModalResetPasswordInfo,closeModalResetPasswordInfo,changeNewReassignEmails
        }
    } = useStore()

    const handleActionChange = (value, data) => {
        switch (value) {
            case 'toggleStatus':
                activeUserOrDeActiveUser(data.id, !data.isActive);
                break;

            case 'resetPassword':
                openModalResetPassword(
                    `${data.firstName} ${data.lastName}`,
                    data.id,
                );
                break;

            case 'reassignEmail':
                openModalReassignEmail(data.email);
                break;

            default:
                break;
        }
    };

    //Get colors code https://ant.design/docs/spec/colors

    const styles = {
        actionButton: {
            width:"130px"
        },
        activeButton: {
            width:"130px", background: "#389e0d"
        },
        deActiveButton: {
            width:"130px", background: "#f5222d"
        },
        addressAndPropertyColumns: {
            width: "calc(100% + 34px)",
            margin: "-17px"
        },
        addressAndPropertyRow: {
            borderBottom: "solid 1px #f0f0f0",
            padding: "15px 15px"
        },
        addressAndPropertyRowLast: {
            padding: "15px 15px"
        }
    }

    const changeReassignEmail = (target: any) => {
        if(target != undefined && target != null){
            const residentKey = target?.split('#')[0]
            const contactKey = target?.split('#')[1]
            changeNewReassignEmails(residentKey,contactKey)
        }else{
            messageApi.open({
                type: 'error',
                content: "Oops, something went wrong. Try refreshing the page and repeating the steps. If this error persists, please contact the development department.",
                duration: 10
            });
        }
    }

    const reassignEmailUser = () => {
        const key = 'updatableReassignEmailUser';
        messageApi.open({
            type: 'loading',
            key,
            content: `Email reassignment process in progress`,
        });
        utilsFunc.reassignEmailFunc(reassignEmail,selectedNewResidentKey,selectedNewContactKey).then(()=>{
            setTimeout(()=> {
                messageApi.open({
                    type: 'success',
                    key,
                    content: `Email reassignment Success!`,
                    duration: 2,
                });
                    closeModalReassignEmail()
                    getUserListToManageAction(data.search==null ? "" : data.search,data.pageNum)
            },250)
        }).catch(err=>{
            setTimeout(()=> {
                messageApi.open({
                    type: 'error',
                    key,
                    content: `Email reassignment Error: ${err}`,
                    duration: 2,
                });
                closeModalReassignEmail()
            },250)
        })
    }

    const resetPasswordUser = (id:number) => {
        const key = 'updatableResetPasswordUser';
        messageApi.open({
            type: 'loading',
            key,
            content: `Password reset process...`,
        });

        getUserResetPasswordWeb(id).then(res=>{
            setTimeout(()=> {
                messageApi.open({
                    type: 'success',
                    key,
                    content: `The process is completed!`,
                });
                closeModalResetPassword();
                openModalResetPasswordInfo(res.data)
            },250)

        }).catch(err=>{
            setTimeout(()=> {
                messageApi.open({
                    type: 'error',
                    key,
                    content: `The process ended with an Error: ${err}`,
                    duration: 2,
                });
                closeModalResetPassword();
            },250)

        })
    }

    const activeUserOrDeActiveUser = (id: number, active:boolean) =>{
        const key = 'updatable';
        messageApi.open({
            type: 'loading',
            key,
            content: active ? <span>Activate User for id: {id}</span> : <span>Deactivate User for id: {id}</span>,
        });
        utilsFunc.activeUserOrDeActiveUserFunc(id,active).then(()=>{
            setTimeout(()=> {
                messageApi.open({
                    type: 'success',
                    key,
                    content: active ? <span>Activate User for id: {id} Success!</span> : <span>Deactivate User for id: {id} Success!</span>,
                    duration: 2,
                });
                    getUserListToManageAction(data.search==null ? "" : data.search,data.pageNum)
            },250)
        }).catch(err=>{
            setTimeout(()=> {
                messageApi.open({
                    type: 'error',
                    key,
                    content: active ? <span>Activate User for id: {id} Error: {err}</span> : <span>Deactivate User for id: {id} Error: {err}</span>,
                    duration: 2,
                });
            },250)
        })

    }

    const columns = [
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            render: (text) => <span>{text}</span>,
        },
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            render: (text) => <span>{text}</span>,
        },
        {
            title: 'Address',
            dataIndex: 'communities',
            key: 'communities',
            render: (_, { communities }) => (
                <RenderAddressAndPropertyColumns
                    data={communities}
                    filed="address"
                    styles={styles}
                />
            ),
        },
        {
            title: 'Property',
            dataIndex: 'communities',
            key: 'communities',
            render: (_, { communities }) => (
                <RenderAddressAndPropertyColumns
                    data={communities}
                    filed="property"
                    styles={styles}
                />
            ),
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: (text) => <span>{text}</span>,
        },
        {
            title: 'Registration Date',
            dataIndex: 'modified',
            key: 'modified',
            render: (text) => <span>{text}</span>,
        },
        {
            title: 'User Status',
            dataIndex: 'isActive',
            key: 'id',
            width: 80,
            render: (key: boolean) => (
                <span>
                    <Tag color={key ? 'green' : 'volcano'} key={1}>
                        {key ? <span>Active</span> : <span>Inactive</span>}
                    </Tag>
                </span>
            ),
        },
        {
            title: 'Email Verified',
            dataIndex: 'emailVerified',
            key: 'id',
            width: 80,
            render: (key: boolean) => (
                <span>
                    <Tag color={key ? 'green' : 'volcano'} key={1}>
                        {key ? <span>Yes</span> : <span>No</span>}
                    </Tag>
                </span>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            width: 140,
            render: (_, data) => {
                const actionOptions = [
                    {
                        label: data.isActive ? 'Deactivate' : 'Activate',
                        value: 'toggleStatus',
                    },
                    {
                        label: 'Reset Password',
                        value: 'resetPassword',
                    },
                    {
                        label: 'Reassign Email',
                        value: 'reassignEmail',
                    },
                ];

                return (
                    <Select
                        value={null}
                        placeholder="Action"
                        style={{ width: 120 }}
                        popupMatchSelectWidth={false}
                        options={actionOptions}
                        onChange={(value) => handleActionChange(value, data)}
                    />
                );
            },
        },
    ];

    useEffect( () => { 
        getUserListToManageAction()
    },[])

    return (
        <div>
            {isLoading && <Spinner />}
            {contextHolder}
            <RenderModalWindowReassignEmail isOpen={isOpenModalReassignEmail} isError={isReassignEmailError} onOk={reassignEmailUser} onCancel={closeModalReassignEmail} onChange={(t: any) => changeReassignEmail(t)} email={reassignEmail} newEmails={newReassignEmails} />
            <RenderModalResetPassword isOpen={isOpenModalResetPassword} onOk={() => resetPasswordUser(accountIdResetPassword)} onCancel={closeModalResetPassword} fullName={fullNameResetPassword} id={accountIdResetPassword} />
            <RenderModalResetPasswordMessage isOpen={isOpenModalResetPasswordInfo} newPassword={newTimePassword} onOk={closeModalResetPasswordInfo}/>
            <div style={{ marginBottom: 16 }}>
                <Row>
                    <Col span={24}>
                        <DynamicTable
                            columns={columns}
                            data={data?.users ?? []}
                            pagination={false}
                            rowKey="id"
                            onRow={() => ({})}
                            onChange={() => undefined}
                            scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }}
                        />
                    </Col>
                </Row>
            </div>
            <Row>
                <Col span={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>{
                    !isLoading && data?.users?.length > 0?
                        <Pagination onChange={(target)=> {getUserListToManageAction(data?.search==null ? "" : data?.search,target - 1)}} showTotal={() => `${data?.from+1}-${data?.to} of ${data?.total} items`} current={data?.pageNum+1} total={data?.total} defaultPageSize={20} showSizeChanger={false} /> 
                        :
                        <></>
                    }
                </Col>
            </Row>
        </div>
    ) 
})
